<div [ngStyle]="{'background': color}" style="width: 50px;height: 50px;" class="boxwrapper round-borders" (click)="openDialog()">
</div>
